import { QueryConfig } from "store/utils/query-config";

export const sendingDomainsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
